const data = {
  products: [
    {
      id: "1",
      name: "Beef and Barley Bun",
      price: 1400,
      image:
        "https://rawcdn.githack.com/OdongAlican/alican-restaurant/036e7c0f75222c583ea6e74bdd5d4f2a404115a2/dist/images/image_four.jpg",
    },
    {
      id: "2",
      name: "Aubergine Dip",
      price: 2400,
      image:
        "https://rawcdn.githack.com/OdongAlican/alican-restaurant/036e7c0f75222c583ea6e74bdd5d4f2a404115a2/dist/images/image_two.jpg",
    },
    {
      id: "3",
      name: "Baked Teriyaki chicken",
      price: 1000,
      image:
        "https://rawcdn.githack.com/OdongAlican/alican-restaurant/036e7c0f75222c583ea6e74bdd5d4f2a404115a2/dist/images/image_three.jpg",
    },
  ],
};
export default data;
